import { create } from "zustand";
import { persist } from "zustand/middleware";

const useInventoryStore = create(
    persist(
        (set) => ({
            inventory: [],
            setInventory: (inventory) => set({ inventory }),
        }),
        {
            name: "inventory-store",
        }
    )
);

export default useInventoryStore;   